import { FC, ReactElement, SVGProps } from 'react';
import { Icon, IconSize } from '@livechat/design-system-react-components';
import {
  ChatBotColored,
  HelpDeskColored,
  KnowledgeBaseColored,
  LiveChatColored,
  OpenWidgetColored,
  PlatformColored,
  HelloColored as TeamChatColored,
  TextLogo,
  RosetteDiscountCheck,
} from '@livechat/design-system-icons';

import { Product } from 'types/product';

type ProductIcon = (props: SVGProps<SVGSVGElement>) => ReactElement;

const getProductIcon = (product: Product): ProductIcon | null => {
  switch (product) {
    case Product.LiveChat:
      return LiveChatColored;
    case Product.HelpDesk:
      return HelpDeskColored;
    case Product.KnowledgeBase:
      return KnowledgeBaseColored;
    case Product.ChatBot:
      return ChatBotColored;
    case Product.OpenWidget:
      return OpenWidgetColored;
    case Product.Platform:
      return PlatformColored;
    case Product.TeamChat:
      return TeamChatColored;
    case Product.PartnerProgram:
      return RosetteDiscountCheck;
    case Product.Accounts:
      return TextLogo;
    default:
      return null;
  }
};

type Props = {
  product: Product;
  size?: IconSize;
  onClick?: () => void;
};

export const Logo: FC<Props> = ({ product, size, onClick }) => {
  const icon = getProductIcon(product);

  if (!icon) {
    return null;
  }

  return (
    <div onClick={onClick}>
      <Icon source={icon} size={size} />
    </div>
  );
};
